function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79 0C2.592 0 0 2.463 0 5.5v5C0 13.537 2.593 16 5.79 16h8.42c3.197 0 5.79-2.463 5.79-5.5v-5C20 2.463 17.407 0 14.21 0zm-.6 3.886a.815.815 0 0 0-1.1.184.726.726 0 0 0 .195 1.044l4.96 3.3c.454.3 1.056.3 1.51 0l4.96-3.3a.726.726 0 0 0 .195-1.044.815.815 0 0 0-1.099-.184l-4.81 3.199z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.3a4bbf9a42632909b17d9d7942ad432f.svg";
export { ForwardRef as ReactComponent };